// extracted by mini-css-extract-plugin
export default {"footerLink":"footer_footerLink__TT7SI"};